import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

interface RequestDisablePolicyParams {
	id: string;
}

export function useDisablePolicy() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id }: RequestDisablePolicyParams) => {
			try {
				return (
					await api.post('/management/policy-version/disable', {
						policyVersionId: id,
					})
				).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao desativar política');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['policies'] });
		},
		onError: (error) => {
			console.error(
				'Erro ao atualizar o estado do termo:',
				getApiErrorMessage(error, 'Erro ao atualizar o estado do termo.')
			);
		},
	});
}
